/**
 * Converts string to PascalCase. Used primarily to convert tagNames to ClassNames.
 * @param string string to be converted to PascalCase
 * @returns string in PascalCase
 */
export function kebabOrSnakeCaseToPascalCase(string) {
    return `${string}`
        .toLowerCase()
        .replace(new RegExp(/[-_]+/, 'g'), ' ')
        .replace(new RegExp(/[^\w\s]/, 'g'), '')
        .replace(new RegExp(/\s+(.)(\w*)/, 'g'), (_, $2, $3) => `${$2.toUpperCase() + $3}`)
        .replace(new RegExp(/\w/), (s) => s.toUpperCase());
}
//# sourceMappingURL=toPascalCase.js.map